import { ref, onUnmounted } from 'vue'
import { eventBus } from '@/utils/eventBus'

const TOAST_EVENT = 'app:toast'
const DEFAULT_DURATION = 4000

const globalToast = ref({
  show: false,
  message: '',
  messageKey: '',
  type: 'success',
})

export function useToast() {
  let timer = null
  let removeListener = null

  function showToast(message, type = 'success', duration = DEFAULT_DURATION) {
    clearTimeout(timer)
    globalToast.value.show = true
    globalToast.value.message = message
    globalToast.value.messageKey = ''
    globalToast.value.type = type
    timer = setTimeout(() => {
      globalToast.value.show = false
    }, duration)
  }

  function hideToast() {
    clearTimeout(timer)
    globalToast.value.show = false
  }

  if (!removeListener) {
    removeListener = eventBus.on(TOAST_EVENT, ({ message, messageKey, type }) => {
      globalToast.value.show = true
      globalToast.value.message = message || ''
      globalToast.value.messageKey = messageKey || ''
      globalToast.value.type = type || 'error'
      clearTimeout(timer)
      timer = setTimeout(() => {
        globalToast.value.show = false
      }, DEFAULT_DURATION)
    })
  }

  onUnmounted(() => {
    if (removeListener) removeListener()
    clearTimeout(timer)
  })

  return {
    toast: globalToast,
    showToast,
    hideToast,
  }
}

export function triggerGlobalToast(message, type = 'error') {
  eventBus.emit(TOAST_EVENT, { message, type })
}

export function triggerGlobalToastByKey(messageKey, type = 'error') {
  eventBus.emit(TOAST_EVENT, { messageKey, type })
}
